import { render } from "./z-task-modal.vue?vue&type=template&id=3db8381d&scoped=true"
import script from "./z-task-modal.vue?vue&type=script&lang=js"
export * from "./z-task-modal.vue?vue&type=script&lang=js"

import "./z-task-modal.vue?vue&type=style&index=0&id=3db8381d&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db8381d"]])

export default __exports__